function inviteTeamMembersDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/invite-team-members/invite-team-members-dialog.html?$$REVISION$$'
  }
}

export { inviteTeamMembersDialogDirective }
